// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__162r4","errors":"Errors_errors__1_EuI"};